// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a5ce2e47","977":"298a131c"}[chunkId] + ".chunk.js";
};